import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-df2d5832"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "user-exam-body-container"
};
var _hoisted_2 = {
  key: 0,
  class: "object-container"
};
var _hoisted_3 = {
  class: "left-container"
};
var _hoisted_4 = {
  key: 4
};
var _hoisted_5 = {
  class: "left-container-footer"
};
var _hoisted_6 = /*#__PURE__*/_createTextVNode("上一题");
var _hoisted_7 = /*#__PURE__*/_createTextVNode("下一题");
var _hoisted_8 = {
  class: "more-tip"
};
var _hoisted_9 = {
  class: "right-container"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "sheet-title"
  }, "答题卡", -1);
});
var _hoisted_11 = {
  class: "question-menu-container"
};
var _hoisted_12 = {
  class: "ide-container"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  key: 1,
  class: "iframe-saving-spin"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c;
  var _component_QuestionTypeHeader = _resolveComponent("QuestionTypeHeader");
  var _component_QuestionProgram = _resolveComponent("QuestionProgram");
  var _component_QuestionChoice = _resolveComponent("QuestionChoice");
  var _component_QuestionFillBlank = _resolveComponent("QuestionFillBlank");
  var _component_QuestionFile = _resolveComponent("QuestionFile");
  var _component_a_button = _resolveComponent("a-button");
  var _component_UserInfoCard = _resolveComponent("UserInfoCard");
  var _component_QuestionMenu = _resolveComponent("QuestionMenu");
  var _component_a_spin = _resolveComponent("a-spin");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!_ctx.questionService.showIde ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_QuestionTypeHeader, {
    questionTypeId: _ctx.questionService.question.questionTypeId,
    index: _ctx.questionService.currentIndex,
    totalNum: _ctx.questionService.currentQuestionType.questionDtoList.length,
    totalScore: _ctx.questionService.currentQuestionType.questionsTotalScore
  }, null, 8, ["questionTypeId", "index", "totalNum", "totalScore"]), _createElementVNode("div", {
    class: "main-content",
    ref: "mainContentRef",
    onScroll: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.updateShowMoreTipDebounce && _ctx.updateShowMoreTipDebounce.apply(_ctx, args);
    })
  }, [_ctx.questionService.isProgram ? (_openBlock(), _createBlock(_component_QuestionProgram, {
    key: _ctx.questionService.question.id,
    question: _ctx.questionService.question,
    answerMode: _ctx.examService.answerMode,
    hasPaperAnswer: _ctx.examService.hasPaperAnswerRecord,
    markRecordData: _ctx.questionService.currentQuestionMarkRecordTableData,
    onShow: _ctx.questionService.showIdeEvent
  }, null, 8, ["question", "answerMode", "hasPaperAnswer", "markRecordData", "onShow"])) : _ctx.questionService.isChoice ? (_openBlock(), _createBlock(_component_QuestionChoice, {
    key: (_a = _ctx.questionService.question) === null || _a === void 0 ? void 0 : _a.id,
    question: _ctx.questionService.question,
    answerMode: _ctx.examService.answerMode,
    currentPaperAnswer: _ctx.questionService.currentQuestionPaperAnswer,
    onChange: _ctx.onChoiceChange
  }, null, 8, ["question", "answerMode", "currentPaperAnswer", "onChange"])) : _ctx.questionService.isFillBlank ? (_openBlock(), _createBlock(_component_QuestionFillBlank, {
    key: ((_b = _ctx.questionService.question) === null || _b === void 0 ? void 0 : _b.id) + '',
    question: _ctx.questionService.question,
    answerMode: _ctx.examService.answerMode,
    currentPaperAnswer: _ctx.questionService.currentQuestionPaperAnswer,
    onChange: _ctx.onInputChange
  }, null, 8, ["question", "answerMode", "currentPaperAnswer", "onChange"])) : _ctx.questionService.isAttachment ? (_openBlock(), _createBlock(_component_QuestionFile, {
    key: ((_c = _ctx.questionService.question) === null || _c === void 0 ? void 0 : _c.id) + '-file',
    question: _ctx.questionService.question,
    answerMode: _ctx.examService.answerMode,
    currentPaperAnswer: _ctx.questionService.currentQuestionPaperAnswer,
    onChange: _ctx.onFileUploaded
  }, null, 8, ["question", "answerMode", "currentPaperAnswer", "onChange"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, "不支持当前题型"))], 544), _createElementVNode("div", _hoisted_5, [!_ctx.questionService.isFirstQuestion ? (_openBlock(), _createBlock(_component_a_button, {
    key: 0,
    type: "default",
    shape: "round",
    size: "large",
    class: "btn-nav-question",
    onClick: _ctx.questionService.goToPrevQuestion
  }, {
    default: _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), !_ctx.questionService.isLastQuestion ? (_openBlock(), _createBlock(_component_a_button, {
    key: 1,
    type: "primary",
    shape: "round",
    size: "large",
    class: "btn-nav-question",
    onClick: _ctx.questionService.goToNextQuestion
  }, {
    default: _withCtx(function () {
      return [_hoisted_7];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(function () {
      return [_withDirectives(_createElementVNode("div", _hoisted_8, "下滑查看更多", 512), [[_vShow, _ctx.showMoreTip]])];
    }),
    _: 1
  })])]), _createElementVNode("div", _hoisted_9, [_ctx.examService.userInfo4Exam ? (_openBlock(), _createBlock(_component_UserInfoCard, {
    key: 0,
    avatar: _ctx.examService.userInfo4Exam.userAvatar,
    name: _ctx.examService.userInfo4Exam.userName,
    sex: _ctx.examService.userInfo4Exam.sex,
    grade: _ctx.examService.userInfo4Exam.grade
  }, null, 8, ["avatar", "name", "sex", "grade"])) : _createCommentVNode("", true), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_QuestionMenu, {
    list: _ctx.examService.exam.questionsDtoList,
    selectQuestion: _ctx.questionService.selectQuestion
  }, null, 8, ["list", "selectQuestion"])])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_ctx.questionService.firstTimeShowIde ? (_openBlock(), _createElementBlock("iframe", {
    ref: "ideIframeRef",
    key: _ctx.questionService.ideIframeUrl,
    src: _ctx.questionService.ideIframeUrl,
    width: "100%",
    height: "100%",
    frameborder: "0",
    title: "",
    allow: "camera; microphone",
    onLoad: _cache[1] || (_cache[1] =
    //@ts-ignore
    function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return _ctx.onIdeIframeLoaded && _ctx.onIdeIframeLoaded.apply(_ctx, args);
    })
  }, null, 40, _hoisted_13)) : _createCommentVNode("", true), _ctx.questionService.isProgram && _ctx.questionService.ideIframeSaving ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_a_spin, {
    style: {
      "height": "100%"
    },
    size: "large",
    tip: "正在全力保存IDE数据中..."
  })])) : _createCommentVNode("", true)])]);
}